// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-enter-active[data-v-005294b3],.dropdown-leave-active[data-v-005294b3]{transition:all .2s ease}.dropdown-enter-from[data-v-005294b3],.dropdown-leave-to[data-v-005294b3]{opacity:0;transform:translateY(-10px)}.line-clamp-2[data-v-005294b3]{-webkit-line-clamp:2;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
